function getByPath(object, path) {
  const pathArray = path.split(".");
  return pathArray.reduce((accumulator, current) => accumulator?.[current], object);
}
export {
  getByPath
};
//# sourceMappingURL=getByPath.js.map
